import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {Backend} from '@generated-backend-types';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ContentHeaderService} from '../../../services/content-header.service';
import {TitleService} from '../../../services/title.service';
import {ActivatedRoute} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {takeUntil} from 'rxjs';
import Patient = Backend.App.Resources.Dashboard.Patient;
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {PrivateFileBrowserComponent} from '../../../components/private-file-browser/private-file-browser.component';
import PrivateAttachmentAttachableTypeEnum = Backend.App.Enums.Administration.Attachments.PrivateAttachmentAttachableTypeEnum;
import PrivateAttachmentTypeEnum = Backend.App.Enums.Administration.Attachments.PrivateAttachmentTypeEnum;
import {PatientService} from '../../../services/api/patients/patient.service';

@Component({
  selector: 'app-authenticated-patients-documents',
  templateUrl: './documents.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TabSwitcherComponent,
    PrivateFileBrowserComponent,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsComponent extends AuthenticatedBaseComponent implements OnInit {
  public patient?: Patient;

  public constructor(
    protected override readonly cdr: ChangeDetectorRef,
    protected override readonly translate: TranslateService,
    protected override readonly contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly patientService: PatientService,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }

  public ngOnInit() {
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      const patient: Patient | undefined = data['patient'];

      if (patient) {
        this.patient = patient;
        this.cdr.markForCheck();
      }

      this.titleService.setTitle('authenticated.patients.documents.title');
    });
  }

  public onReloadRequested() {
    if (this.patient) {
      this.patientService.get(this.patient.id, true)
        .subscribe(res => {
          this.patient = res.data;
          this.cdr.markForCheck();
        });
    }
  }

  protected readonly PrivateAttachmentAttachableTypeEnum = PrivateAttachmentAttachableTypeEnum;
  protected readonly PrivateAttachmentTypeEnum = PrivateAttachmentTypeEnum;
}
